class CustomSommelierFavorites extends HTMLElement {
    constructor() {
      super();
      this._boundUpdateAddButtonState = this.updateAddButtonState.bind(this);
    }

    connectedCallback() {
      this.init();
    }

    disconnectedCallback() {
      this.querySelector('.somm_fav_add')?.removeEventListener('click', this._boundUpdateAddButtonState);
    }

    init() {
      const addButton = this.querySelector('.somm_fav_add');
      if (addButton) {
        addButton.addEventListener('click', () => this.addFavoriteItem());
      }
      this.updateAddButtonState();
    }

    addFavoriteItem(data = null) {
      const maxFavorites = this._tryParseInt(this.getAttribute('max-favorites')) ?? 3;
      const currentFavorites = this.querySelectorAll('custom-sommelier-favorite-item');
      const container = this.querySelector('.somm_fav_items_container');
      
      if (!container || currentFavorites.length >= maxFavorites) return;

      const newFavoriteItem = document.createElement('custom-sommelier-favorite-item');
      currentFavorites.forEach(fav => fav.removeAttribute('expanded'));
      newFavoriteItem.setAttribute('expanded', '');
      
      // If data is provided, set it as a data attribute
      if (data) {
        // Ensure all required fields are present in the data
        const completeData = {
          title: data.title || '',
          description: data.description || '',
          wine_type: data.wine_type || ''
        };
        newFavoriteItem?.setAttribute('data-initial', JSON.stringify(completeData));
      }
      
      container.appendChild(newFavoriteItem);
      this.updateAddButtonState();

      // console.log("==> New favorite item appended", newFavoriteItem);
    }

    updateAddButtonState() {
      const maxFavorites = this._tryParseInt(this.getAttribute('max-favorites')) ?? 3;
      const currentFavorites = this.querySelectorAll('custom-sommelier-favorite-item');
      const addButton = this.querySelector('.somm_fav_add');
      
      if (!addButton) return;

      addButton.toggleAttribute('disabled', currentFavorites.length >= maxFavorites);
    }

    _tryParseInt(value) {
      if (value === null || value === undefined) return null;
      const parsed = parseInt(value, 10);
      return isNaN(parsed) ? null : parsed;
    }
}

customElements.define('custom-sommelier-favorites', CustomSommelierFavorites);

class CustomSommelierFavoriteItem extends HTMLElement {
    constructor() {
      super();
      this._boundToggleExpanded = this._toggleExpanded.bind(this);
      this._boundDeleteItem = this._deleteItem.bind(this);
    }

    connectedCallback() {
      const parent = this.closest('custom-sommelier-favorites');
      if (!parent) return;
      
      const template = parent.querySelector('template');
      if (!template) return;


      const clone = template.content.cloneNode(true);

      this.appendChild(clone);
      this.init();

      this._populateInitialData();
    }
    
    _populateInitialData() {
      const initialData = this.getAttribute('data-initial');
      if (!initialData) return;
  
      try {
        const data = JSON.parse(initialData);
        
        // Populate title
        const titleInput = this.querySelector('input[name="somm_fav_title"]');
        if (titleInput && data.title) {
          titleInput.value = data.title;
          // Trigger input event to ensure any listeners are notified
          titleInput.dispatchEvent(new Event('input', { bubbles: true }));
        }
  
        // Populate description
        const descriptionInput = this.querySelector('textarea[name="somm_fav_description"]');
        if (descriptionInput && data.description) {
          descriptionInput.value = data.description;
          // Trigger input event to ensure any listeners are notified
          descriptionInput.dispatchEvent(new Event('input', { bubbles: true }));
        }

        // Populate wine type (select element) - with a small delay to ensure DOM is ready
        setTimeout(() => {
          const wineTypeSelect = this.querySelector('select[name="somm_fav_wine_type"]');
          
          if (wineTypeSelect && data.wine_type) {
            
            // Find the option with the matching value
            const option = Array.from(wineTypeSelect.options).find(opt => opt.value === data.wine_type);
            
            if (option) {
              wineTypeSelect.value = data.wine_type;
              // Trigger change event to ensure any listeners are notified
              wineTypeSelect.dispatchEvent(new Event('change', { bubbles: true }));
            } else {
              console.warn('No matching option found for wine_type:', data.wine_type);
            }
          } else {
            console.warn('Wine type select not found or no wine_type data');
          }
        }, 100);
  
        // Remove the data attribute after populating
        this.removeAttribute('data-initial');
      } catch (error) {
        console.warn('Error populating favorite item data:', error);
      }
    }

    disconnectedCallback() {
      const btnDropdown = this.querySelector('.icon-button');
      const deleteBtn = this.querySelector('[data-delete-favorite]');
      
      if (btnDropdown) {
        btnDropdown.removeEventListener('click', this._boundToggleExpanded);
      }
      if (deleteBtn) {
        deleteBtn.removeEventListener('click', this._boundDeleteItem);
      }
    }

    init() {
      const btnDropdown = this.querySelector('.icon-button');
      const deleteBtn = this.querySelector('[data-delete-favorite]');

      if (btnDropdown) {
        btnDropdown.addEventListener('click', this._boundToggleExpanded);
      }

      if (deleteBtn) {
        deleteBtn.addEventListener('click', this._boundDeleteItem);
      }
    }

    _toggleExpanded() {
      this.toggleAttribute('expanded');
      const parent = this.closest('custom-sommelier-favorites');
      if (parent) {
        parent.updateAddButtonState();
      }
    }

    _deleteItem() {
      const parent = this.closest('custom-sommelier-favorites');
      this.remove();
      if (parent) {
        parent.updateAddButtonState();
      }
    }
}

customElements.define('custom-sommelier-favorite-item', CustomSommelierFavoriteItem);